import React, { Component } from 'react';
import NodeId from '../nodes/NodeId'
import history from '../../history'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class Omniauth extends Component {

  componentDidMount() {
    const { name, token } = this.props.match.params
    cookies.set('api_access_token', token, { path: '/' })
    cookies.set('name', name, { path: '/' })
  }

  render() {
    let id = cookies.get('lastClickedId')

    if(id === null || id.length < 5){
      history.push('/')
      return null
    } else {
      return  <NodeId id={id} />
    }

  }
}

export default Omniauth



// WEBPACK FOOTER //
// ./src/components/SignupLogin/Omniauth.js